import React from "react";
import { Typography, Box } from "@mui/material";
import { BaseToolResult } from "./BaseToolResult";

interface AddNumbersToolResultProps {
  result: { sum: number };
  args: { num1: number; num2: number };
}

export const AddNumbersToolResult: React.FC<AddNumbersToolResultProps> = ({
  result,
  args,
}) => {
  return (
    <BaseToolResult icon="➕">
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Typography component="span" sx={{ fontWeight: "bold", color: "primary.main" }}>
          {args.num1}
        </Typography>
        <Typography component="span" variant="body1">
          +
        </Typography>
        <Typography component="span" sx={{ fontWeight: "bold", color: "primary.main" }}>
          {args.num2}
        </Typography>
        <Typography component="span" variant="body1">
          =
        </Typography>
        <Typography component="span" sx={{ fontWeight: "bold", color: "primary.main", fontSize: "1.1rem" }}>
          {result.sum}
        </Typography>
      </Box>
    </BaseToolResult>
  );
};